import PlayerBarMinified from './PlayerBarMinified'

export default PlayerBarMinified
